<template>
  <div class="container mt-4">
    <h2 class="mb-4">Order History</h2>

    <!-- Venue and Bar Selectors -->
    <SelectVenue class="mb-3" ref="venueDropDown" @updateVenue="updateVenue" />
    <SelectBar
      v-if="venue_id !== '' && venue_id !== '0'"
      :venueId="venue_id"
      :liveOrder="true"
      :optional="true"
      class="mb-3"
      ref="barDropDown"
      @updateBar="updateBar"
    />

    <!-- Preset Ranges -->
    <div class="mb-3">
      <button class="btn btn-outline-secondary me-2" @click="setDateRange('3months')">Last 3 Months</button>
      <button class="btn btn-outline-secondary me-2" @click="setDateRange('1month')">Last Month</button>
      <button class="btn btn-outline-secondary me-2" @click="setDateRange('1week')">Last Week</button>
      <button class="btn btn-outline-secondary" @click="setDateRange('24hours')">Last 24 Hours</button>
    </div>


    <!-- Date Selectors and Preset Buttons -->
    <div class="row mb-3">
      <div class="col-md-6">
        <label>Start Date</label>
        <input type="date" class="form-control" v-model="startDate" :max="today" :min="threeMonthsAgo" />
      </div>
      <div class="col-md-6">
        <label>End Date</label>
        <input type="date" class="form-control" v-model="endDate" :min="endDateMin" :max="today" />
      </div>
    </div>

    
    <!-- Generate Button -->
    <div class="mb-4">
      <button class="btn btn-primary" @click="fetchHistoricOrders">Generate</button>
    </div>

    
    <div class="order-summary"  v-if="orders.length > 0">
      <div>Total Revenue: <strong>{{ formattedTotalRevenue }}</strong></div>
      <div>Average Order Value: <strong>{{ formattedAverageOrderValue }}</strong></div>
      <div>Total Orders: <strong>{{ filteredOrders.length }}</strong></div>
      <div v-if="totalRefundedOrders>0">Total Refunded Orders: <strong>{{ totalRefundedOrders }}</strong></div>
      <div v-if="totalRefundedOrders>0" >Total Refunded Amount: <strong>{{ formattedTotalRefundedAmount }}</strong></div>
    </div>
     <div  v-if="orders.length > 0" class="d-flex flex-column flex-md-row justify-content-between align-items-md-end mb-4 gap-3">
      
      <!-- Filter Input -->
      <div class="flex-fill">
        <label class="form-label mb-1" for="orderFilter">Search Orders</label>
        <input 
              v-model="filterText"
              type="text"
              placeholder="Search by Order ID"
              class="form-control"
            />
      </div>

      <!-- Order Count -->
      <div class="text-end">
        <small class="text-muted">
          Showing <strong>{{ filteredOrders.length }}</strong> of {{ orders.length }} orders
        </small>
      </div>

      <!-- Export Button -->
      <div>
        <button class="btn btn-primary" @click="exportToCSV">
          <i class="bi bi-download me-1"></i> Export Orders CSV
        </button>
      </div>

      <div>
        <button class="btn btn-primary" @click="exportItemizedToCSV">
          <i class="bi bi-download me-1"></i> Export Items CSV
        </button>
      </div>

      
    </div>
    <!-- Order Grid -->
    <div class="row header" v-if="orders.length > 0" style="background-color: purple;">
      <div class="col-md-1 me-1">{{ getButtonHeader() }}</div>
      <div class="col-md-2 d-none d-md-block">Order_ID</div>
      <div class="col-md-1 d-none d-md-block">Cost</div>
      <div class="col-md-1 d-none d-md-block me-1">Completed?</div>
      <div class="col-md-2 d-none d-md-block">Time of order</div>
      <div class="col-md-2 d-none d-md-block">Time to completion</div>
       <div class="col-md-1 d-none d-md-block">Stripe?</div>
       <div class="col-md-1 d-none d-md-block">Refund</div>
    </div>

    <div
      class="row py-2"
      v-for="(order, index) in filteredOrders"
      :key="index"
    >
      <div class="col-md-1 me-1">
        <button type="button" class="btn text-bg-dark me-2"  v-on:click="openModal(order)">
          {{ getButtonText(order) }}
        </button>
        
      </div>
      <div class="col-md-2 me-1 d-none d-md-block">{{ order.readable_ID }}</div>
      <div class="col-md-1 d-none d-md-block">{{ toDollarAmount(order.total_cost) }}</div>
       <div class="col-md-1 d-none d-md-block me-1">{{ order.is_complete? "Yes" : "No" }}</div>
      <div class="col-md-2 d-none d-md-block">{{ formatDate(order.createdAt) }}</div>
      <div class="col-md-2 d-none d-md-block">{{ timeToComplete(order) }}</div>
      <div class="col-md-1 d-none d-md-block">{{ order.payment_intent_ID ? "Yes" : "No" }}</div>
      <div  class="col-md-1 d-none d-md-block">
        <button
          v-if="order.is_complete === true && order.is_cancelled === false && order.payment_intent_ID"
          type="button"
          class="btn btnSubmit d-none d-md-block"
          @click="refundOrder(order)"
        >
          Refund
        </button>
        <div v-else-if="order.is_refunded === true">
         Yes
        </div>
        <div v-else>
          N/A
        </div>
      </div>
    </div>
    <button v-show="false" type="button" ref="action" data-bs-toggle="modal" data-bs-target="#orderListModal" > <i class="fa-solid fa-plus"></i></button>
    <div class="modal fade" id="orderListModal" ref="modal" tabindex="-1" aria-labelledby="orderList" aria-hidden="true">
        <ViewOrderHistory :order="currentOrder"  @refundOrderModal="refundOrderModal" />
    </div>
      

  </div>
</template>

<script>
import SelectVenue from '@/components/SelectVenue.vue';
import SelectBar from '@/components/SelectBar.vue';
import orderService from "../../api/orders.js"
import swal from 'sweetalert';
import ViewOrderHistory from "../../components/modals/ViewOrderHistory.vue"


export default {
  components: { SelectVenue, SelectBar,ViewOrderHistory },
  data() {
    return {
      venue_id: '',
      bar_id: '',
      startDate: '',
      endDate: '',
      orders: [],
      filterText:'',
      currentOrder:"",
    };
  },
  computed: {
    getVenueNameById() {
      const venue = this.$store.state.venues.find(v => v._id === this.venue_id);
      return venue ? venue.venue_name : 'UnknownVenue';
    },
    totalRevenue() {
      return this.orders
        .filter(order => !order.is_cancelled || !order.is_refunded)
        .reduce((sum, order) => sum + order.total_cost, 0);
    },
    totalGrossRevenue(){
      return this.orders
        .reduce((sum, order) => sum + order.total_cost, 0);
    },
  averageOrderValue() {
    if (this.orders.length === 0) return 0;
    return this.totalGrossRevenue / this.orders.length;
  },
  formattedTotalRevenue() {
    return this.toDollarAmount(this.totalRevenue);
  },
  formattedAverageOrderValue() {
    return this.toDollarAmount(this.averageOrderValue);
  },
   totalRefundedOrders() {
    return this.filteredOrders.filter(order => order.is_refunded).length;
  },

  totalRefundedAmount() {
    return this.filteredOrders
      .filter(order => order.is_refunded)
      .reduce((sum, order) => sum + order.total_cost, 0);
  },

  formattedTotalRefundedAmount() {
    return this.toDollarAmount(this.totalRefundedAmount);
  },
    filteredOrders() {
      const filter = this.filterText.toLowerCase();
      return this.orders.filter(order =>
        order.readable_ID.toLowerCase().includes(filter)
      );
    },
    today() {
      return new Date().toISOString().split('T')[0];
    },
    threeMonthsAgo() {
      const date = new Date();
      date.setMonth(date.getMonth() - 3);
      return date.toISOString().split('T')[0];
    },
    endDateMin() {
        if (this.startDate) {
            const SDate = new Date(this.startDate);
            SDate.setDate(SDate.getDate() + 1); // mutate the date
            return SDate.toISOString().split('T')[0];
        } else {
            const date = new Date();
            date.setMonth(date.getMonth() - 3);
            date.setDate(date.getDate() + 1); // add one day
            return date.toISOString().split('T')[0];
        }
    }
  },
  methods: {
    exportItemizedToCSV() {
      const headers = [
        'Order Readable ID',
        'Order Created Time',
        'Item Name',
        'Item Quantity',
        'Item Cost (with Tax)',
        'Order Refunded',
        'Order Cancelled',
        'Order Complete'
      ];

      const rows = [];

      this.filteredOrders.forEach(order => {
        if (!order.item_list || !Array.isArray(order.item_list)) return;

        order.item_list.forEach(item => {
          rows.push([
            order.readable_ID ?? '',
            this.formatDate(order.created_time) ?? '',
            item.name ?? '',
            item.numberOfDrinks ?? 1, // Default to 1 if not specified
            '$ ' + (item.cost_with_tax) ?? '',
            order.is_refunded ?? '',
            order.is_cancelled ?? '',
            order.is_complete ?? ''
          ]);
        });
      });

      let csvContent = 'data:text/csv;charset=utf-8,';
      csvContent += headers.join(',') + '\n';

      rows.forEach(row => {
        csvContent += row.map(value => `"${value}"`).join(',') + '\n';
      });

      const venueName = this.getVenueNameById.replace(/\s+/g, '_');
      const today = new Date().toISOString().split('T')[0];
      const filename = `items_${venueName}_${today}.csv`;

      const encodedUri = encodeURI(csvContent);
      const link = document.createElement('a');
      link.setAttribute('href', encodedUri);
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    exportToCSV() {
     const headers = [
        'Readable ID',
        'Total Cost',
        'Number of Items',
        'Created Time',
        'Cancelled',
        'Complete',
        'Refunded'
      ];
    const rows = this.filteredOrders.map(order => [
      order.readable_ID ?? '',
      this.toDollarAmount(order.total_cost) ?? '',
      order.number_of_items ?? '',
      this.formatDate(order.created_time) ?? '',
      order.is_cancelled ?? '',
      order.is_complete ?? '',
      order.is_refunded ?? ''
      ]);

    let csvContent = 'data:text/csv;charset=utf-8,';
    csvContent += headers.join(',') + '\n';

    rows.forEach(row => {
      csvContent += row.map(value => `"${value}"`).join(',') + '\n';
    });

    const venueName = this.getVenueNameById.replace(/\s+/g, '_');
      const today = new Date().toISOString().split('T')[0];
      const filename = `orders_${venueName}_${today}.csv`;

    const encodedUri = encodeURI(csvContent);
    const link = document.createElement('a');
    link.setAttribute('href', encodedUri);
    link.setAttribute('download',filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  },
    updateVenue(e) {
      this.venue_id = e.target.value;
    },
    updateBar(e) {
      this.bar_id = e.target.value;
    },
    setDateRange(range) {
      const now = new Date();
      const end = now.toISOString().split('T')[0];
      let start = new Date();

      switch (range) {
        case '3months':
          start.setMonth(now.getMonth() - 3);
          break;
        case '1month':
          start.setMonth(now.getMonth() - 1);
          break;
        case '1week':
          start.setDate(now.getDate() - 7);
          break;
        case '24hours':
          start.setDate(now.getDate() - 1);
          break;
      }

      this.startDate = start.toISOString().split('T')[0];
      this.endDate = end;
    },
    async fetchHistoricOrders() {
      if (!this.venue_id || !this.startDate || !this.endDate) {
       await swal("Please ensure you have a VenueID and a Start and End Date.", {
            icon: "error", // You can customize the icon (info, success, error, warning, question)
          });
        return;
      }

      try {
        const submitEndDate = new Date(this.endDate)
        submitEndDate.setDate(submitEndDate.getDate()+1)
        const data = {
            venueId: this.venue_id,
            barID: this.bar_id || null,
            startDate: new Date(this.startDate).toISOString(),
            endDate: new Date(submitEndDate).toISOString(),
          }
        orderService.getHistoricOrders(data).then(data =>{
            console.log("recieved:")
            console.log(data)
            this.orders = data
        });
      } catch (err) {
        console.error(err);
        alert("Failed to fetch orders.");
      }
    },
    getButtonHeader(){
       return this.screenWidth < 768 ? 'Order Actions' : '-';
    },
    getButtonText(order) {
      return this.screenWidth < 768 ? order.readable_ID : 'Open';
    },
    numberofItems(itemList) {
      return itemList?.length || 0;
    },
    toDollarAmount(amount) {
      return `$${(amount / 100).toFixed(2)}`;
    },
    formatDate(date) {
      return new Date(date).toLocaleString();
    },
    timeToComplete(order) {
    if (!order.venue_start_time || !order.completed_time) return 'N/A';

    const created = new Date(order.venue_start_time);
    const completed = new Date(order.completed_time);
    const diffMs = completed - created;

    const diffMinutes = Math.round(diffMs / 60000); // convert ms to minutes

    return `${diffMinutes} min${diffMinutes !== 1 ? 's' : ''}`;
  },
    openModal(item){
      this.currentOrder=item;
      this.$refs.action.click();
    },
    async refundOrderModal(order){
      await orderService.refundOrder(order._id, order).then(data => {
            if (data && data._id) {
              // Find and update the local order in-place
              swal("Order has been refunded!")
              const index = this.orders.findIndex(o => o._id === data._id);
              if (index !== -1) {
                this.$set(this.orders, index, {
                  ...this.orders[index],
                  is_cancelled: true,
                  is_refunded: true,
                  cancel_reason: 'Order refunded',
                });
              }
            }
          });
    },
    refundOrder(order) {
      swal({
        title: 'Are you sure you want to refund this order? This is not reversable',
        text: 'Refunding an order only returns the subtotal. Platform fees are paid by the customer and not refunded.',
        buttons: {
          cancel: 'Cancel',
          confirm: 'Confirm',
        },
        closeOnClickOutside: false,
      }).then(async (value) => {
        if (value) {
          await orderService.refundOrder(order._id, order).then(data => {
            console.log(data)
            if (data && data._id) {
              // Find and update the local order in-place
              swal("Order has been refunded!")
              const index = this.orders.findIndex(o => o._id === data._id);
              if (index !== -1) {
                this.$set(this.orders, index, {
                  ...this.orders[index],
                  is_cancelled: true,
                  is_refunded: true,
                  cancel_reason: 'Order refunded',
                });
              }
            }
          });
        }
      });
    },
  }
};
</script>
<style scoped>
.order-summary {
  display: flex;
  gap: 2rem;
  margin-bottom: 1rem;
  font-size: 1rem;
}
</style>
